import React from "react";
import { Link } from "react-router-dom";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import PhoneIphoneOutlinedIcon from "@mui/icons-material/PhoneIphoneOutlined";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";
import SupportAgentOutlinedIcon from "@mui/icons-material/SupportAgentOutlined";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import QrCodeScannerOutlinedIcon from "@mui/icons-material/QrCodeScannerOutlined";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import BookOutlinedIcon from "@mui/icons-material/BookOutlined";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import ArrowOutwardOutlinedIcon from "@mui/icons-material/ArrowOutwardOutlined";
import { homeMobileMenus } from "../mobileHomepageMenuData";
import "./megaMenu.css";

const icons = [
  Inventory2OutlinedIcon,
  TrendingUpOutlinedIcon,
  PhoneIphoneOutlinedIcon,
  SecurityOutlinedIcon,
  SupportAgentOutlinedIcon,
  AutoAwesomeOutlinedIcon,
  QrCodeScannerOutlinedIcon,
  WorkOutlineOutlinedIcon,
  BookOutlinedIcon,
  BusinessOutlinedIcon,
];
const descriptions = {
  features: "Run sales, stock, and reporting from one connected workspace.",
  solutions: "Purpose-built workflows for the businesses you manage.",
  learn: "Practical resources to help your team do more with Universe.",
  company:
    "Learn about Universe Tech Industry and the people behind the platform.",
};
const titles = {
  features: "Explore our features",
  solutions: "Find your solution",
  learn: "Learn with Universe",
  company: "Get to know Universe",
};
const featured = {
  features: {
    eyebrow: "YOUR OPERATIONS, CONNECTED",
    title: "A smarter way to manage every transaction.",
    desc: "Explore the capabilities that connect inventory, sales and your team.",
    path: "/company/features",
    action: "View all features",
  },
  solutions: {
    eyebrow: "INDUSTRIES",
    title: "Solutions shaped around your business.",
    desc: "Compare industry workflows and find the right starting point.",
    path: "/solutions/industries",
    action: "Explore industries",
  },
  learn: {
    eyebrow: "GETTING STARTED",
    title: "Build confidence from your first day.",
    desc: "Follow guided topics for setup, inventory, sales and reports.",
    path: "/learning/getting_started",
    action: "Get started",
  },
  company: {
    eyebrow: "OUR COMPANY",
    title: "Technology for businesses that are growing.",
    desc: "Explore our mission, career openings and ways to work with Universe.",
    path: "/about-us",
    action: "About Universe",
  },
};
export default function MegaMenu({ kind }) {
  const groups = homeMobileMenus[kind] || [];
  const feature = featured[kind];
  return (
    <section
      className={`dropDownContent universeMegaMenu universeMegaMenu--${kind}`}
      aria-label={`${kind} navigation`}
    >
      <div className="universeMegaMain">
        <div className="universeMegaIntro">
          <span className="universeMegaKicker">DISCOVER UNIVERSE</span>
          <h3>{titles[kind]}</h3>
          <p>{descriptions[kind]}</p>
        </div>
        <div className="universeMegaGroups">
          {groups.map((group, groupIndex) => (
            <div className="universeMegaGroup" key={group.title}>
              <span className="universeMegaGroupTitle">{group.title}</span>
              <div className="universeMegaLinks">
                {group.items.map((item, i) => {
                  const Icon = icons[(groupIndex * 3 + i) % icons.length];
                  return (
                    <Link
                      key={item.path}
                      to={item.path}
                      className="universeMegaItem"
                    >
                      <span className="universeMegaIcon">
                        <Icon fontSize="large" />
                      </span>
                      <span className="universeMegaText">
                        <strong>{item.title}</strong>
                        <small>{item.description}</small>
                      </span>
                      <ArrowOutwardOutlinedIcon
                        className="universeMegaArrow"
                        fontSize="large"
                      />
                    </Link>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
        {kind === "solutions" && (
          <div className="universeMegaFooter">
            <Link to="/solutions/all-solutions">
              View all solutions <ArrowForwardRoundedIcon fontSize="large" />
            </Link>
            <Link to="/solutions/industries">
              View all industries <ArrowForwardRoundedIcon fontSize="large" />
            </Link>
          </div>
        )}
      </div>
      <div className="universeMegaFeature">
        <span className="universeMegaFeatureOrb">
          <BusinessOutlinedIcon />
        </span>
        <span className="universeMegaFeatureKicker">{feature.eyebrow}</span>
        <h4>{feature.title}</h4>
        <p>{feature.desc}</p>
        <Link to={feature.path}>
          {feature.action} <ArrowForwardRoundedIcon fontSize="large" />
        </Link>
        {kind === "company" && (
          <Link className="universeMegaSecondary" to="/careers">
            Explore careers <ArrowForwardRoundedIcon fontSize="large" />
          </Link>
        )}
        {kind === "features" && (
          <Link
            className="universeMegaSecondary"
            to="/store/universe-mobile/application"
          >
            Mobile apps <ArrowForwardRoundedIcon fontSize="large" />
          </Link>
        )}
      </div>
    </section>
  );
}
